import { createContext, useContext } from 'react';
import type { User } from '@supabase/supabase-js';
import type { SignUpInput, SignInInput, ResetPasswordInput, UpdatePasswordInput } from './validation';

export interface AuthContextType {
  user: User | null;
  loading: boolean;
  error: string | null;
  signUp: (data: SignUpInput) => Promise<any>;
  signIn: (data: SignInInput) => Promise<any>;
  signOut: () => Promise<void>;
  resetPassword: (data: ResetPasswordInput) => Promise<void>;
  updatePassword: (data: UpdatePasswordInput) => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}